import { ISampleType } from "@/models/SampleType";
import makeRequest from "@/api/makeRequest";

const SampleTypesApi = {
  getSampleTypes: async (): Promise<ISampleType[]> => {
    const { data } = await makeRequest<ISampleType[]>({
      url: "/sample-types",
    });
    return data;
  },
  createSampleType: async (type: string): Promise<ISampleType> => {
    const { data } = await makeRequest<ISampleType>({
      url: "/sample-types",
      method: "post",
      data: { type },
    });
    return data;
  },
  editSampleType: async (sampleTypeId: number, type: string): Promise<ISampleType> => {
    const { data } = await makeRequest<ISampleType>({
      url: `/sample-types/${sampleTypeId}`,
      method: "put",
      data: { type }
    });
    return data;
  },
  deleteSampleType: async (sampleTypeId: number): Promise<void> => {
    await makeRequest({
      url: `/sample-types/${sampleTypeId}`,
      method: "delete",
    });
  },
};

export default SampleTypesApi;
